module.exports = __webpack_public_path__ + "img/bell-school.e3f0e9dc.svg";